import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/outdoor/ac-mesh.png";
import type { Product } from "../../types";
import { wifiOutdoor } from "../product-list-groups/wifi-outdoor";
import {
  antennaType,
  connectedDevices,
  extendedRangeMode6Ghz,
  externalAntennaSupport,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "../properties";

export const acMesh: Product = {
  id: "acMesh",
  productTitle: "AC Mesh",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.WiFi}/uap-ac-mesh`,
  ],
  storePathParts: {
    productSlug: "uap-ac-mesh",
    category: UniFiChildCategorySlug.WiFiOutdoor,
  },
  sku: "UAP-AC-M",
  description: "acMesh.description",
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiOutdoor,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '353 x 46 x 34.4 mm\n(13.9 x 1.8 x 1.4")',
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "acMesh.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: extendedRangeMode6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: antennaType.id,
      value: {
        type: "translation",
        value: "acMesh.antennaType.omnidirectional",
        asterisk: 1,
      },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "140 m² (1,500 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "200+" },
    },
    {
      propertyId: externalAntennaSupport.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE" },
    },
    {
      propertyId: uplink.id,
      value: { type: "string", value: "GbE" },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.wallPole",
      },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "string", value: "IPX4" },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
  ],
  notes: ["acMesh.notes.externalAntenna"],
};
